import React, { createContext, useCallback, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";

const MobileNavContext = createContext(null);

export const MobileNavProvider = ({ children }) => {
  const createHandlerRef = useRef(null);
  const navigate = useNavigate();

  const registerCreateHandler = useCallback((handler) => {
    createHandlerRef.current = handler;
    return () => {
      if (createHandlerRef.current === handler) {
        createHandlerRef.current = null;
      }
    };
  }, []);

  const openCreatePost = useCallback(() => {
    if (typeof createHandlerRef.current === "function") {
      createHandlerRef.current();
      return;
    }
    navigate("/community?compose=1");
  }, [navigate]);

  return (
    <MobileNavContext.Provider value={{ registerCreateHandler, openCreatePost }}>
      {children}
    </MobileNavContext.Provider>
  );
};

export const useMobileNav = () => {
  const ctx = useContext(MobileNavContext);
  if (!ctx) {
    throw new Error("useMobileNav must be used within MobileNavProvider");
  }
  return ctx;
};
